module.exports = __webpack_public_path__ + "static/img/知识付费@2x1.38d90e33.png";